import React, { useState, useEffect } from "react";
import { Col, Row, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Input } from "reactstrap";
import { useOutletContext } from "react-router-dom";
import { FormGroup, Spinner, Pagination } from "react-bootstrap";
import { Oval } from "react-loader-spinner";
import ProgressTracker from "./ProgressTracker";
import { getPrintRequestsUserId } from "store/actions";
import { PaginationItem, PaginationLink } from "reactstrap";

export default function PrintRequest(props) {
  const [trackerDialog, settrackerDialog] = useState(false);
  const [search, setSearch] = useState("");
  const [menu, menuopen] = useOutletContext();
  const [data, setData] = useState([]);
  const [printRequest, setPrintRequest] = useState();
  const dispatch = useDispatch();
  const user_id = useSelector((s) => s.Login?.user?._id);
  var { printRequsets, loading } = useSelector((s) => s?.Print);

  useEffect(() => {
    menu(false);
  }, [menu]);
  useEffect(() => {
    if (user_id) {
      dispatch(getPrintRequestsUserId({ user_id: user_id }));
    }
  }, [user_id, dispatch]);
  const trackerbtn = (item) => {
    if (trackerDialog === false) {
      setPrintRequest(item);
    } else {
      setPrintRequest();
    }

    settrackerDialog(!trackerDialog);
  };
  /// pagination
  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(10);
  var [sNoValue, setSNovalue] = useState(0);
  useEffect(() => {
    setData(printRequsets);
  }, [printRequsets]);
  useEffect(() => {
    var x = 0;
    if (data?.length < 9) {
      x = 1;
    } else {
      x = Math.ceil(data.length / 10);
    }
    for (let i = 1; i <= x; i++) {
      if (!dataLength.includes(i)) {
        dataLength.push(i);
      }
    }
  }, [data, search, dataLength]);

  useEffect(() => {
    let arr = [];
    setSNovalue(values - 10);
    for (let i = values - 10; i < values; i++) {
      if (data[i]) {
        arr.push(data[i]);
      }
    }
    setDataAfterPagination(arr);
  }, [values, data, search]);

  const handlePagination = (val) => {
    var valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = parseInt(values) - 10;
    } else if (val === ">" && sNoValue / 10 < values) {
      valu = (parseInt(values / 10) + 1) * 10;
    } else if (val === ">>" && values < data.length) {
      valu = Math.ceil(data.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues(valu);
  };

  useEffect(() => {
    console.log("printRequsets", printRequsets);
    if (printRequsets?.length > 0) {
      setData(
        printRequsets?.filter((item) => {
          if (!search) return item; // If search is empty, return all items.

          const searchLower = search.toLowerCase();
          const name = item?.nft_id?.name?.toLowerCase() || ""; // Safely handle null/undefined.
          const trackId = item?.order_track_id?.toLowerCase() || ""; // Safely handle null/undefined.

          // Check if either `name` or `trackId` includes the search string.
          return name.includes(searchLower) || trackId.includes(searchLower);
        })
      );
    }
  }, [search, printRequsets]);
  useEffect(() => {
    setDataLength([1]);
    setValues(10);
  }, [search]);
  return (
    <>
      {loading && (
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}
      <Modal
        className="EmailVerifyBoxModel printDialog text-center"
        show={trackerDialog}
        centered
        animation={false}
      >
        <ProgressTracker fucn={trackerbtn} request={printRequest} />
      </Modal>
      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <h1 className="mb-0">
              <i onClick={menuopen} className="fa-light fa-bars-sort"></i> Print
              Requests
            </h1>
          </div>
        </Col>
      </Row>
      <div className="TabsData mt-4">
        <Row className="justify-content-between">
          <Col lg={6}>
            <FormGroup className="position-relative">
              <Input
                className="form-control searchInput"
                placeholder="Search by Artwork Name, Track ID"
                onChange={(e) => setSearch(e.target.value)}
              />
              <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0">
                <i className="fa-light fa-magnifying-glass"></i>
              </button>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="table-responsive tableNft">
              <table>
                <thead>
                  <tr>
                    <td className="text-center">No.</td>
                    <td>Artwork Name</td>
                    <td className="text-center">Cost</td>
                    <td className="text-center">Quantity</td>
                    <td className="text-center">Track ID</td>
                    <td className="text-center">Status</td>
                    <td className="text-center">Action</td>
                  </tr>
                </thead>
                <tbody>
                  {dataAfterPagination.length > 0 ? (
                    dataAfterPagination.map((item, ind) => (
                      <tr key={ind}>
                        <td className="text-center">{sNoValue + ind + 1}</td>
                        <td>
                          <img
                            className="nftimge"
                            alt=""
                            src={
                              item?.nft_image ||
                              item?._physical_image?.link ||
                              item?.nft_id?.image_id?.image
                                ?.water_mark_image_link ||
                              "/images/no-image.png"
                            }
                          />
                          {item?.nft_name ||
                            item?._physical?.listing_title ||
                            item?.nft_id?.name ||
                            item?.item_info?.name?.replace(
                              /\.[^/.]+$/,
                              ""
                            ) ||
                            "Untitled Artwork"}
                        </td>

                        <td className="text-center">
                          {"$ " + item?.total_cost}
                        </td>
                        <td className="text-center">1</td>
                        <td className="text-center">{item?.order_track_id}</td>
                        <td className="text-center status-pending">
                          {item?.order_tracking_status[
                            item?.order_tracking_status.length - 1
                          ]?.status === "Order Received"
                            ? "Order Placed"
                            : item?.order_tracking_status[
                                item?.order_tracking_status.length - 1
                              ]?.status}
                        </td>
                        <td className="text-center">
                          <button
                            className="btn border-0"
                            onClick={() => trackerbtn(item)}
                          >
                            <i className="fa-regular fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                            <>
                              <tr>
                                <td colSpan={8}>
                                  <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                    <img
                                      src={"/images/svg/mpdatanft.svg"}
                                      className="mb-4"
                                      alt="Create collection"
                                    />
                                    <h3>
                                      No Print Request Found
                                    </h3>
                                  </div>
                                </td>
                              </tr>
                            </>
                          )}
                </tbody>
              </table>
            </div>

            {dataAfterPagination.length > 0 && (
              <Col lg={12} className="text-end">
                <Pagination
                  className="paginationNew"
                  aria-label="Page  navigation example"
                >
                  {values > 10 && (
                    <div className="d-flex align-items-center gap-2">
                      <PaginationItem>
                        <PaginationLink
                          first
                          href="#"
                          onClick={() => handlePagination("<<")}
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          href="#"
                          previous
                          onClick={() => handlePagination("<")}
                        />
                      </PaginationItem>
                    </div>
                  )}
                  {dataLength &&
                    dataLength.map((item) => (
                      <PaginationItem
                        className={
                          parseInt(item) === values / 10 ? "active" : ""
                        }
                      >
                        <PaginationLink
                          href="#"
                          onClick={() => handlePagination(item)}
                        >
                          {item}
                        </PaginationLink>
                      </PaginationItem>
                    ))}

                  {values < data.length && (
                    <div className="d-flex align-items-center gap-2">
                      <PaginationItem>
                        <PaginationLink
                          href="#"
                          next
                          onClick={() => handlePagination(">")}
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          href="#"
                          last
                          onClick={() => handlePagination(">>")}
                        />
                      </PaginationItem>
                    </div>
                  )}
                </Pagination>
              </Col>
            )}
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spinner animation="border" size="sm" role="status"></Spinner>
      ) : (
        ""
      )}
    </>
  );
}
